module.exports = {
      id: "mail-usage",
      viewBox: "0 0 18 19",
      url: __webpack_public_path__ + "img/icons.56e2db0a.svg#mail-usage",
      toString: function () {
        return this.url;
      }
    }